import type { SupportData } from './types';

export const SUPPORT_DATA: SupportData = {
  tickets: [
    {
      member: 'Derek Washington',
      memberId: 'derek-washington',
      status: 'open',
      subject: 'App login issue — can\'t access member directory',
      summary: 'Reported inability to log into the FC app. Last active in app 3 weeks ago. Has been experiencing decreasing engagement overall.',
      sentiment: 'Neutral but frustration building',
      daysSince: 4,
    },
  ],
  quietMembers: [
    {
      id: 'raj-patel',
      name: 'Raj Patel',
      initials: 'RP',
      lastSeen: '67 days ago',
      detail: 'No Slack, no events, no mastermind attendance since December',
    },
    {
      id: 'derek-washington',
      name: 'Derek Washington',
      initials: 'DW',
      lastSeen: '18 days ago',
      detail: 'Engagement dropped 60% in 30 days. App login issue reported.',
    },
    {
      id: 'tom-fitzgerald',
      name: 'Tom Fitzgerald',
      initials: 'TF',
      lastSeen: '11 days ago',
      detail: 'Attending masterminds but silent in Slack. Renewal in 5 months.',
    },
  ],
} as const;
